import React from "react";
import Footer from "../../layout/Footer";
import constants from "../../constants";
import endPoints from "../../shared/services/endPoints";

export default function PrivacyPolicy() {
  return (
    <>
      <div className="py-1">
        <iframe
          src={constants.baseUrl + endPoints.PRIVACY_POLICY}
          title="Privacy Policy"
          width="100%"
          height="600"
          style={{
            border: "none",
            overflow: "hidden",
          }}
          loading="lazy"
        />
      </div>
      {/* </div>
      </div> */}
      <Footer />
    </>
  );
}
